import { PageLayout } from "~/components/PageLayout";
import { SettingsLayout } from "~/features/settings/components/SettingsLayout";

export const SettingsPage = () => {
  return (
    <PageLayout>
      <SettingsLayout />
    </PageLayout>
  );
};
